export default "__VITE_ASSET__ZXpgC99u__"